import { render, staticRenderFns } from "./CarterClinicalDrillDown.vue?vue&type=template&id=19fc6313&"
import script from "./CarterClinicalDrillDown.vue?vue&type=script&lang=ts&"
export * from "./CarterClinicalDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports